export default __webpack_public_path__ + "static/media/shopify-icon.5dc92f96.svg";